import { numberFormatter } from "./number-formatter";

export function currencyFormatter(input: string): string {
  const value = numberFormatter(input);

  if (typeof value !== "number" || isNaN(value)) {
    return "";
  }

  const currency = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(value);

  return currency;
}
